<!-- 注册画面 -->
<template>
	<div>
		<Head1  :titleVal="$t('components.head1.title.register')"  :type="type"></Head1>
		<div class="mainArea">
			<div class="title">{{$t('pages.register.title1')}}<span class="blue">{{$t('pages.register.title2')}}</span>{{$t('pages.register.title3')}}</div>
			<div class="label" v-if="currentLanguage==='zh-CN'">{{$t('pages.register.phoneLabel')}}<span class="redText">*</span></div>
			<div class="inputArea" v-if="currentLanguage==='zh-CN'">
				<input type="text" :placeholder="$t('pages.register.phonePlaceholder')" class="telInput" v-model="form.mobile"/>
			</div>

			<div class="label" v-if="currentLanguage==='en-US'">{{$t('pages.register.emailLabel')}}<span class="redText">*</span></div>
			<div class="inputArea" v-if="currentLanguage==='en-US'">
				<input type="text" :placeholder="$t('pages.register.emailPlaceholder')" class="telInput" v-model="form.email"/>
			</div>
			<div class="label">{{$t('pages.register.verifyCodeLabel')}}</div>
			<div class="inputArea">
				<input type="text" class="codeInput" :placeholder="$t('pages.register.codePlaceholder')" v-model="form.checkCode"/>
				<button class="codeBtn"  v-if="!isCountdown" @click="startCountdown(60)">{{$t('pages.register.getCode')}}</button>		
				<button class="codeBtn" v-if="isCountdown" disabled>{{$t('pages.register.reGetCCode', { time: countdown })}}</button>
			</div>
			<div class="label">{{$t('pages.register.countryLabel')}}<span class="redText">*</span></div>
			<div class="inputArea">
				<select class="countryArea " v-model="selectCountry">
					<option v-for="(country,index) in countries" :key="country.id" :value="country">
						{{ country.name }}</option>
				</select>
			</div>

			<div class="label">{{$t('pages.register.enterpriseLabel')}}<span class="redText">*</span></div>
			<div class="inputArea">
				<input type="text" :placeholder="$t('pages.register.enterprisePlaceholder')" class="telInput" v-model="form.enterprise"/>
			</div>
			<div class="label">{{$t('pages.register.contactLabel')}}<span class="redText">*</span></div>
			<div class="inputArea">
				<input type="text" :placeholder="$t('pages.register.contactPlaceholder')" class="telInput" v-model="form.contactMan"/>
			</div>
			<div class="label" v-if="currentLanguage==='zh-CN'">{{$t('pages.register.emailLabel')}}<span class="redText">*</span></div>
			<div class="inputArea" v-if="currentLanguage==='zh-CN'">
				<input type="text" :placeholder="$t('pages.register.emailPlaceholder')" class="telInput" v-model="form.email"/>
			</div>
			<div class="registerBtn" @click="register()">{{$t('pages.register.submitBtn')}}</div>
			<div class="registerFoot"><input type="checkbox"  v-model="form.isCheck" /> {{$t('pages.register.agree1')}} <span>{{$t('pages.register.agree2')}}</span><span>{{$t('pages.register.agree3')}}</span></div>
		</div>
		<Foot1  :type="type"></Foot1>
	</div>
	
</template>

<script>
	import Head1 from '../components/head1.vue';
	import Foot1 from '../components/foot1.vue';
	export default{
		components:{
			Head1,
			Foot1
		},
		data() {
			return {
				titleStr: '账号注册',
				type:'REISTER',
				countdown: 0,
				isCountdown: false,
				form:{
					mobile:'',
					checkCode:'',
					isCheck:false,
					contactMan:'',
					enterprise:'',
					email:'',	
				},
				countries: [],
				selectCountry:{},
				currentLanguage:localStorage.getItem('locale-lang')||'zh-CN',
			}			
		}, 
		created()
		{
			this.getCountryInfo();
		},
		methods: {
			startCountdown(seconds) {
				var currentLanguage=this.currentLanguage;
				if(currentLanguage==='zh-CN')
				{
					this.$scUtil.axiosPut(this, 'CommonApi/Execute', {
					cellphone: this.form.mobile,
					operate: 'sendsms',
				}, res => {
					console.log(res.code);
					if (res.code == 100) {
						this.$message({message: res.message,type: "success"});
						this.isCountdown = true;
						this.countdown = seconds;

						const interval = setInterval(() => {
							if (this.countdown > 0) {
							this.countdown -= 1;
							} else {
							clearInterval(interval);
							this.isCountdown = false;
							}
						}, 1000);
					}else
					{
						this.$message({message: res.message,type: "warning"});
					}

				});
				}
				else if(currentLanguage==='en-US')
				{
					this.$scUtil.axiosPut(this, 'CommonApi/Execute', {
					email: this.form.email,
					operate: 'sendEmail',
				}, res => {
					console.log(res.code);
					if (res.code == 100) {
						this.$message({message: res.message,type: "success"});
						this.isCountdown = true;
						this.countdown = seconds;

						const interval = setInterval(() => {
							if (this.countdown > 0) {
							this.countdown -= 1;
							} else {
							clearInterval(interval);
							this.isCountdown = false;
							}
						}, 1000);
					}else
					{
						this.$message({message: res.message,type: "warning"});
					}

				});
				}
				
			  
			},
			register()
			{
				if(!this.form.isCheck)
				{
					this.$message({message: this.$t('pages.register.please_accept'), type: "warning"});
					return;
				}
				this.$scUtil.axiosPut(this, 'MemberApi/Register', {
					cellphone: this.form.mobile,
					checkCode: this.form.checkCode,
					enterprise: this.form.enterprise,
					contactMan: this.form.contactMan,
					email: this.form.email,
					countryId:this.selectCountry.id
				}, res => {
					console.log(res.code);
					if (res.code == 100) {
						this.$message({message: this.$t('pages.register.register_success'),type: "success"});
						let loginToken = res.message;
						console.log(loginToken)
						localStorage.setItem('logintoken', "Bearer "+loginToken);
						localStorage.setItem('username',res.data.userId);
						this.$router.push({ name: "IndexVue" });
				
					}else
					{
						this.$message({message: this.$t('pages.register.register_fail'),type: "warning"});
					}
				
				});
			},
			getCountryInfo() {
				this.$scUtil.axiosPost(this, 'CountryApi/GetCountryList', {
				}, res => {
					if (res.code == 100) {
						this.countries = res.data;
						this.selectCountry=this.countries[0];
						//console.log(this.categoryList);
					}
			
				});
			},
		},
	}
</script>

<style scoped>
	.title{
		font-size: 28px;
		color: #000000;
		margin: 62px 0; 
	}
	
	.blue{
		color: #0380fe;
	}
	
	
	.label{
		font-size: 15px;
		color: #333333;
		width: 415px;
		text-align: left;
		margin-bottom:  12px;
	}
	
	.redText{
		color:#db050f;
	}
	
	.mainArea{
		display: flex;
		flex-direction: column;
		align-items: center;
		padding-bottom: 100px;
	}
	
	.inputArea{
		margin-bottom:25px;
	}
	
	
	.telInput{
		width: 415px;
		height: 50px;
		border: 1px solid #cdcdcd;
		padding: 0 11px;
		font-size: 13px;
		color: #000;
		box-sizing: border-box;
	}
	
	.telInput::placeholder,
	.codeInput::placeholder{
	  color: #888888;
	  font-size: 13px;
	}
	
	input:focus{
		outline: none;
	}
	
	.codeInput{
		width: 262px;
		height: 49px;
		border:1px solid #cdcdcd;
		margin-right:13px;
		padding: 0 11px;
		box-sizing: border-box;
	}
	
	.registerBtn{
		width: 415px;
		height: 53px;
		text-align: center;
		line-height: 53px;
		color: #fff;
		border: 1px solid #0380fe;
		background-color: #0380fe;
		font-size: 20px;
		cursor: pointer;
		border-radius:10px;
	}
	
	.codeBtn{
		width: 140px;
		height: 49px;
		border: 1px solid #0380fe;
		color: #333333;
		font-size: 14px;
		background-color: #fff;
		cursor: pointer;
	}
	
	.registerFoot{
		font-size: 13px;
		color: #888888;
		margin-top: 28px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		width: 415px;
	}
	
	.registerFoot span{
		color: #0380fe;
		cursor: pointer;
	}
	.countryArea {
		width: 415px;
		height: 50px;
		border: 1px solid #cdcdcd;
		padding: 0 11px;
	}
</style>